import { jsxs, jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import cns from '../../node_modules/classnames/index.js';

const Colors = ['alarm', 'warning', 'success', 'info', 'safe'];
/**
Le progress servono per informare l’utente circa il tempo di attesa di un’operazione.
Quando il tempo preciso non si conosce si utilizzano quelle indeterminate.
 */
function Progress({ className, indeterminate, percentage, text, color, }) {
    const percentageValues = useMemo(() => {
        const values = Array.isArray(percentage) ? percentage : [percentage];
        let total = 0;
        return values.map((v, i) => {
            const probObj = typeof v === 'number' ? { percentage: v } : v;
            const obj = {
                percentage: probObj.percentage + total,
                key: i,
                className: probObj.color && Colors.includes(probObj.color) ? probObj.color : undefined,
                color: probObj.color && probObj.color.startsWith('#') ? probObj.color : undefined,
            };
            total += probObj.percentage;
            return obj;
        });
    }, [percentage]);
    return (jsxs("div", { className: cns('progress', {
            'progress--indeterminate': indeterminate,
        }, className), children: [!indeterminate && percentageValues.map((p, i, arr) => (jsxs("div", { className: "progress__bar-item", children: [jsx("div", { className: cns('progress__bar', 'progress__bar--item', p.className), style: {
                            width: `${p.percentage}%`,
                            zIndex: 2 * (arr.length - i) + 1,
                            backgroundColor: p.color,
                        } }), jsx("div", { className: "progress__bar progress__bar--separator", style: {
                            width: `${p.percentage}%`,
                            zIndex: 2 * (arr.length - i),
                        } })] }, p.key))), jsx("div", { className: "progress__bar", style: { width: indeterminate ? '0%' : (`${percentage}%`) } }), jsx("div", { className: cns('progress__bufferbar', (Colors.includes(color) ? color : undefined)), style: { width: '100%', backgroundColor: (color && color.startsWith('#') ? color : undefined) } }), text && jsx("div", { className: "progress__text", children: text })] }));
}
Progress.defaultProps = {
    className: '',
    indeterminate: false,
    percentage: 0,
    text: '',
    color: undefined,
};

export { Progress as default };
